import { z } from 'zod';
import { tokenFieldsSchema } from '@/models/tokenRefreshSchema';

export const loginSchema = z
  .object({
    info: z.string(),
    login: z.string(),
    token: z.string(),
    userId: z.number().nonnegative(),
  })
  .merge(tokenFieldsSchema);
